const apiTokensSortReducer = (
    state = {},
    action: {
      type: "SET_API_TOKENS_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_API_TOKENS_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default apiTokensSortReducer;